/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IChangePasswordModalScope extends ng.IScope {
        modalClose: () => void;
        modalSave: () => void;

        oldPassword: string;
        newPassword: string;
        confirmedNewPassword: string;

        oldPasswordHidden: boolean;
        passwordHidden: boolean;
        confirmPasswordHidden: boolean;

        toggleOldPasswordVisibility: () => void;
        togglePasswordVisibility: () => void;
        toggleConfirmPasswordVisibility: () => void;
    }

    export class ChangePasswordModalController {
        public static templateURL: string = "decorators/modals/change-password-modal.html";
        public static ID: string = "#id-change-password";
        public static $name: string = "changePasswordModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'userService'];

        private $scope: IChangePasswordModalScope;
        private close: (result: boolean) => void;
        private $timeout: ng.ITimeoutService;

        /**
         * Constructor
         */
        constructor($scope: IChangePasswordModalScope,
                    close: (result: boolean) => void,
                    $timeout: ng.ITimeoutService,
                    private userService: Services.UserService) {

            $timeout(() => {
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.close = close;
            this.$timeout = $timeout;

            this.$scope.oldPasswordHidden = true;
            this.$scope.passwordHidden = true;
            this.$scope.confirmPasswordHidden = true;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.toggleOldPasswordVisibility = (): void => {
                this.$scope.oldPasswordHidden = !this.$scope.oldPasswordHidden;
            };
            this.$scope.togglePasswordVisibility = (): void => {
                this.$scope.passwordHidden = !this.$scope.passwordHidden;
            };
            this.$scope.toggleConfirmPasswordVisibility = (): void => {
                this.$scope.confirmPasswordHidden = !this.$scope.confirmPasswordHidden;
            };

            this.$scope.modalSave = (): void => {
                const oldPassword: string = this.$scope.oldPassword;
                const newPassword: string = this.$scope.newPassword;
                const confirmedPassword: string = this.$scope.confirmedNewPassword;

                const fieldsNotEmpty: boolean = oldPassword && newPassword && confirmedPassword &&
                                                oldPassword !== '' && newPassword !== '' && confirmedPassword !== '';
                const newPasswordMatches: boolean = newPassword === confirmedPassword;

                if (fieldsNotEmpty && newPasswordMatches) {
                    this.userService.updatePassword(oldPassword, newPassword)
                    .then((passwordUpdated: boolean) => {
                        if (passwordUpdated) {
                            Common.Utils.alertOnSuccess('Password updated correctly.', 'bottom-center');
                            this.close(true);
                        } else {
                            Common.Utils.alertOnError('Incorrect password.', 'bottom-center');
                        }
                    });
                }

            };
        }
    }
}